import { useState } from "react";
import { Check, Send } from "lucide-react";

const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-");

const pill = (on) =>
  `inline-flex min-h-[48px] items-center gap-2 rounded-full border px-5 text-sm font-semibold transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#C5A059] disabled:opacity-50 ${
    on ? "border-[#2C1810] bg-[#2C1810] text-[#FDFBF7]" : "border-[#2C1810] bg-transparent text-[#2C1810] hover:bg-[#2C1810] hover:text-[#FDFBF7]"}`;

export function QuickChoices({ choices, onSubmit, disabled, mid }) {
  const qs = (choices?.questions || []).filter((q) => q?.options?.length).slice(0, 3);
  const [picked, setPicked] = useState({});
  if (!qs.length) return null;
  const instant = qs.length === 1 && !qs[0].multi;

  const toggle = (q, opt) => {
    if (instant) return onSubmit(opt);
    const cur = picked[q.id] || [];
    const next = !q.multi ? [opt]
      : opt === "None of these" ? (cur.includes(opt) ? [] : [opt])
        : cur.includes(opt) ? cur.filter((o) => o !== opt) : [...cur.filter((o) => o !== "None of these"), opt];
    setPicked({ ...picked, [q.id]: next });
  };

  const answered = qs.filter((q) => picked[q.id]?.length);
  const submit = () => {
    const parts = answered.map((q) => (qs.length === 1 ? picked[q.id].join(", ") : `${q.label || q.id}: ${picked[q.id].join(", ")}`));
    onSubmit(parts.join("\n"));
  };

  return (
    <div className="space-y-5 pt-1" data-testid={`quick-choices-${mid}`}>
      {qs.map((q, qi) => (
        <fieldset key={q.id || qi} disabled={disabled}>
          {(qs.length > 1 || q.multi) && (
            <legend className="mb-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#6E5549]">
              {q.label || `Question ${qi + 1}`}{q.multi && <span className="ml-1 normal-case tracking-normal">— select all that apply</span>}
            </legend>
          )}
          <div className="flex flex-wrap gap-3">
            {q.options.map((opt) => {
              const on = (picked[q.id] || []).includes(opt);
              return (
                <button key={opt} type="button" onClick={() => toggle(q, opt)} aria-pressed={on} data-testid={`choice-${slug(q.id || qi)}-${slug(opt)}`} className={pill(on)}>
                  {on && <Check size={14} strokeWidth={3} />}{opt}
                </button>
              );
            })}
          </div>
        </fieldset>
      ))}
      {!instant && (
        <div className="flex flex-wrap items-center gap-3">
          <button type="button" onClick={submit} disabled={disabled || !answered.length} data-testid={`quick-choices-send-${mid}`}
            className="inline-flex min-h-[48px] items-center gap-2 rounded-full bg-[#C5A059] px-6 text-sm font-semibold text-[#2C1810] hover:bg-[#b48f4a] disabled:cursor-not-allowed disabled:opacity-40">
            <Send size={15} /> Send {answered.length > 1 ? "answers" : "answer"}
          </button>
          <span className="text-xs text-[#6E5549]">{qs.length > 1 && answered.length < qs.length ? "Answer one or both — or type below." : "Or type more detail below."}</span>
        </div>
      )}
    </div>
  );
}
